import React, { useEffect, useReducer, useState } from "react";
import { useConfig } from "./config";
import { borderColor, darken, lighten, readableColor } from "polished";

export const ThemeContext = React.createContext(null);

const initialState = {
  /* General colors */
  backgroundColorNavBar: "#333",
  textColorNavbar: "#ffffff",
  backgroundColorFooter: darken(0.1, "#0f2844"),
  backgroundColorMain: "#ffffff",
  textColorDefault: "#333",

  /* ListCourses */
  backgroundColorBannerBtn: "#fdbf00",
  TextColorBannerBtn: "#333",
  backgroundColorCardBtn: "#fdbf00",
  TextColorCardBtn: "#202020",
  backgroundBajada: "#f5f5f5",

  /* Detail Course */
  backgroundColorDetailCourse: "#ffffff",
  backgroundColorPrevBtn: "#fdbf00", // amarillo
  backgroundColorNextBtn: "#1a4275",
  backgroundColorIndexRow: "#fdbf00",
  backgroundColorCurrentTab: "#fdbf00",
  backgroundColorNotCurrentTab: "#12284b",
  backgroundColorCurrentModule: "#1a4275",
  backgroundColorNotCurrentModule: "#0f233d",
  borderColorCurrentModule: "#fdbf00",

  /* vista historial */

  /* Vista contacto */

  /* Login */
  backgroundColorHeader: "#0f233d",
  backgroundColorBody: "#1a4275",

  /* default palette */
  primary_light: "#1a4275",
  primary_dark: "#1a4275",
  secondary_light: "#12284b",
  secondary_dark: "#12284b",
  tertiary_light: "#0f233d",
  tertiary_dark: "#0f233d",
  background_dark: "#0f2844",
  background_light: "#0f2844",
  button_light: "#fdbf00",
  button_dark: "#fdbf00",
};
const reducer = (state, action) => {
  switch (action.type) {
    case "SET_COLOR":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "SET_COLORS":
      return {
        ...state,
        ...action.payload.colors,
      };
    default:
      return state;
  }
};

export const ThemeProvider = ({ children }) => {
  const { config } = useConfig();
  const [colors, dispatch] = useReducer(reducer, initialState);
  const [mode, setMode] = React.useState(
    localStorage.getItem("darkMode") || "light"
  );
  const [layout, setLayout] = useState(true);

  useEffect(() => {
    if (config) {
      let configTheme = config.config.theme;
      console.log("config: ", config);
      //* Aquí irán los colores organizados por su ubicación
      setColors({
        /* backgroundColorButtonTabs: mode === "light" ? configTheme.colors.tertiary_light : configTheme.colors.tertiary_dark, */
        /* backgroundColorCurrentModule:configTheme.colors.primary_light, */
        /* backgroundColorNotCurrentModule: mode === "light" ? configTheme.colors.secondary_light : configTheme.colors.secondary_dark, */
        /* backgroundColorPrevBtn: mode === "light" ? configTheme.colors.tertiary_light : configTheme.colors.tertiary_dark, */
        backgroundColorDefault: mode === "light" ? "#ffffff" : "#333",
        backgroundColorDetailCourse: mode === "light" ? "#ffffff" : configTheme.colors.background_dark,

        /* General colors */
        backgroundColorNavBar: mode === "light" ? configTheme.colors.background_light : configTheme.colors.background_dark,
        textColorNavbar: mode === "light" ? configTheme.colors.text_navbar_light : configTheme.colors.text_navbar_dark,
        backgroundColorFooter: configTheme.colors.background_dark && darken(0.1, configTheme.colors.background_dark),
        backgroundColorMain: mode === "light" ? configTheme.colors.background_light : configTheme.colors.background_dark,
        textColorDefault: mode === "light" ? "#333" : "#fff",
        backgroundColorBody: mode === "light" ? configTheme.colors.background_body_light ? configTheme.colors.background_body_light: "#ffffff" : configTheme.colors.background_body_dark ? configTheme.colors.background_body_dark : configTheme.colors.background_dark, // aclaro que este será el color de fondo principal del sitio.

        /* ListCourses */
        backgroundColorBannerBtn: mode === "light" ? configTheme.colors.background_banner_button_light : configTheme.colors.background_banner_button_dark,
        TextColorBannerBtn: configTheme.colors.background_banner_button_light && readableColor(mode === "light" ? configTheme.colors.background_banner_button_light : configTheme.colors.background_banner_button_dark),
        backgroundColorCardBtn: mode === "light" ? configTheme.colors.button_light: configTheme.colors.button_dark,
        TextColorCardBtn: mode === "light" ? configTheme.colors.text_button_light : configTheme.colors.text_button_dark,
        backgroundBajada: mode === "light" ? "#f5f5f5" : "#031226",

        /* Detail Course */
        backgroundColorIndexRow: configTheme.colors.button_light,
        backgroundColorCurrentTab: configTheme.colors.button_light,
        borderColorCurrentModule: configTheme.colors.button_light,
        backgroundColorPrevBtn: configTheme.colors.button_light,
        backgroundColorCurrentModule: configTheme.colors.primary_light,
        backgroundColorNextBtn: mode === "light" ? configTheme.colors.primary_light : configTheme.colors.primary_dark,
        backgroundColorNotCurrentTab: darken(0.1, configTheme.colors.primary_light),
        backgroundColorNotCurrentModule: darken(0.2, configTheme.colors.primary_light),

        /* vista historial */
        backgroundPendienteLight: configTheme.colors.background_pendiente_light ? configTheme.colors.background_pendiente_light : configTheme.colors.button_light,
        backgroundPendienteDark: configTheme.colors.background_pendiente_dark ? configTheme.colors.background_pendiente_dark : configTheme.colors.button_dark,
        backgroundCompletadoLight:configTheme.colors.background_completado_light ? configTheme.colors.background_completado_light : configTheme.colors.button_light,
        backgroundCompletadoDark: configTheme.colors.background_completado_dark ?  configTheme.colors.background_completado_dark :configTheme.colors.button_dark,
        backgroundTooltipLight: configTheme.colors.background_tooltip_light ? configTheme.colors.background_tooltip_light : "#fdbf00",
        backgroundTooltipDark: configTheme.colors.background_tooltip_dark ? configTheme.colors.background_tooltip_dark : "#fdbf00",

        /* login */
        backgroundColorHeaderLogin: configTheme.colors.background_header_login ? configTheme.colors.background_header_login : "#000",
        backgroundColorBodyLogin: configTheme.colors.background_body_login ? configTheme.colors.background_body_login : "#000",
        /* default palette */
        primary_light: configTheme.colors.primary_light,
        primary_dark: configTheme.colors.primary_dark,
        secondary_light: configTheme.colors.secondary_light,
        secondary_dark: configTheme.colors.secondary_dark,
        tertiary_light: configTheme.colors.tertiary_light,
        tertiary_dark: configTheme.colors.tertiary_dark,
        background_dark: configTheme.colors.background_dark,
        background_light: configTheme.colors.background_light,
        button_light: configTheme.colors.button_light,
        button_dark: configTheme.colors.button_dark,
        text_button_dark:configTheme.colors.text_button_dark,
        text_button_light:configTheme.colors.text_button_light,
        text_navbar_dark:configTheme.colors.text_navbar_dark,
        text_navbar_light:configTheme.colors.text_navbar_light,
        text_login_light:configTheme.colors.text_login_light,
        text_login_dark:configTheme.colors.text_login_dark,
        background_banner_light:configTheme.colors.background_banner_light,
        background_banner_dark:configTheme.colors.background_banner_dark,
        background_banner_button_dark:configTheme.colors.background_banner_button_dark,
        background_banner_button_light:configTheme.colors.background_banner_button_light,

        /* theme loaded validator */
        themeLoaded: true,
      });
    }

    // eslint-disable-next-line
  }, [config.config.theme, mode]);

  function handleContentLayout() {
    setLayout(!layout);
  }

  let actions = {
    handleDarkMode: function () {
      if (mode === "light") {
        setMode("dark");
        localStorage.setItem("darkMode", "dark");
        document.querySelector("#root").style.backgroundColor =
          "rgb(34, 34, 34)";
      } else {
        setMode("light");
        localStorage.setItem("darkMode", "light");
        document.querySelector("#root").style.backgroundColor = "#f5f5f5";
      }
    },
  };

  const setColor = (key, value) => {
    dispatch({ type: "SET_COLOR", payload: { key, value } });
  };

  const setColors = (colors) => {
    dispatch({ type: "SET_COLORS", payload: { colors } });
  };

  let value = {
    actions,
    mode,
    layout,
    handleContentLayout,
    colors,
    setColor,
    setColors,
  };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};
export const useTheme = () => React.useContext(ThemeContext);
